import { useEffect, useState } from 'react';
import request from 'lib/request';
import { nameToOption } from 'config/questionOptions';

const ATTRIBUTE_PARAMS = { select: ['id', 'name'], pageSize: 0 };

const toNameOptions = (response) =>
  (response?.data ?? [])
    .map((attribute) => attribute?.name)
    .filter(Boolean)
    .map(nameToOption);

/**
 * Loads the attribute names available as a reference-date source for a
 * "Date" quantitative question: work object custom fields and company
 * attributes. Returns options keyed by source type (`wo` / `company`).
 */
export default function useMeasureSourceAttributes() {
  const [options, setOptions] = useState({ wo: [], company: [] });

  useEffect(() => {
    let active = true;

    Promise.all([
      request.get('/settings/wo-custom-attributes', { params: ATTRIBUTE_PARAMS }),
      request.get('/settings/company-attributes', { params: ATTRIBUTE_PARAMS }),
    ])
      .then(([woResponse, companyResponse]) => {
        if (!active) return;
        setOptions({
          wo: toNameOptions(woResponse),
          company: toNameOptions(companyResponse),
        });
      })
      .catch(() => {
        if (active) setOptions({ wo: [], company: [] });
      });

    return () => {
      active = false;
    };
  }, []);

  return options;
}
